/* BRIXIES – 0,25 € Einwegpfand, exclusively for Energy Drink. */
(() => {
  'use strict';
  const ENERGY = 59112104493320;
  const DEPOSIT = 59157197291784;
  let busy = false;
  const route = endpoint => (window.Shopify?.routes?.root || '/') + 'cart/' + endpoint;

  async function send(endpoint, data) {
    const response = await fetch(route(endpoint), {
      method:'POST',
      headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify(data)
    });
    const result = await response.json();
    if (!response.ok || result.status) {
      throw new Error(result.description || result.message || 'Shopify hat die Warenkorbänderung abgelehnt');
    }
    return result;
  }

  function sectionsForUpdate() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles:true, detail:{sections} })
    );
    return sections;
  }

  async function currentCart() {
    const response = await fetch((window.FoxTheme?.routes?.cart_url || ((window.Shopify?.routes?.root || '/') + 'cart')) + '.js', {cache:'no-store'});
    if (!response.ok) throw new Error('Warenkorb konnte nicht geladen werden');
    return response.json();
  }

  function publish(cart, context = {}) {
    if (window.FoxTheme?.pubsub) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {cart, ...context});
    } else {
      // Fallback for atypical pages without the FoxTheme component.
      document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true,detail:{open:false}}));
    }
  }

  function errorMessage(error) {
    console.error('[BRIXIES Pfand] Warenkorb-API:', error);
    alert('Die Änderung konnte nicht gespeichert werden. Bitte versuche es erneut.');
  }

  function lineKey(cartRow, variantId) {
    const scope = cartRow?.closest('cart-items') || document;
    const line = [...scope.querySelectorAll('[data-variant-id][data-line-key]')]
      .find(el => Number(el.dataset.variantId) === variantId);
    return line?.dataset.lineKey || null;
  }

  async function changeEnergyQuantity(line, quantity, row, items, name, target) {
    if (busy) return;
    busy = true;
    const buttonSet = row?.querySelectorAll('button, input.quantity__input') || [];
    buttonSet.forEach(element => element.disabled = true);
    items?.showLoader?.(line);
    try {
      let energyKey = row?.dataset?.lineKey;
      let depositKey = lineKey(row, DEPOSIT);
      if (!energyKey || !depositKey) {
        // Only for out-of-date/cached markup; normal interactions have both keys in HTML.
        const current = await currentCart();
        energyKey = current.items.find(item => Number(item.variant_id) === ENERGY && !item.parent_relationship)?.key;
        depositKey = current.items.find(item => Number(item.variant_id) === DEPOSIT)?.key;
      }
      if (!energyKey) throw new Error('Energy-Drink-Warenkorbzeile fehlt');
      const desired = Math.max(0, Number(quantity));
      if (!Number.isInteger(desired)) throw new Error('Ungültige Menge');
      const updates = {[energyKey]:desired};
      // Shopify removes nested items automatically when the parent is removed.
      if (depositKey && desired > 0) updates[depositKey] = desired;
      const result = await send('update.js', {
        updates,
        sections:sectionsForUpdate(),
        sections_url:window.location.pathname
      });
      publish(result, {target, line, name});
      // No second cart fetch, no recursive reconciliation, no redundant alerts.
    } catch (error) {
      errorMessage(error);
      buttonSet.forEach(element => element.disabled = false);
      document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{open:false}}));
    } finally {
      busy = false;
    }
  }
  window.BrixiesDeposit = {changeEnergyQuantity, energyVariant:ENERGY, depositVariant:DEPOSIT};

  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[is="product-form"]')) return;
    if (Number(form.querySelector('[name="id"]')?.value) !== ENERGY) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    const button = form.querySelector('[type="submit"]');
    if (button?.disabled || button?.getAttribute('aria-disabled') === 'true') return;
    busy = true;
    button?.setAttribute('aria-disabled','true');
    button?.classList.add('btn--loading');
    try {
      const count = Math.max(1, parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10) || 1);
      const properties = {};
      for (const [key,value] of new FormData(form).entries()) {
        if (key.startsWith('properties[') && key.endsWith(']')) {
          properties[key.slice(11,-1)] = value;
        }
      }
      properties._units_per_item = '1';
      properties._deposit_variant = String(DEPOSIT);
      const added = await send('add.js', {
        items:[
          {id:ENERGY, quantity:count, properties},
          {id:DEPOSIT, quantity:count, parent_id:ENERGY, properties:{_is_deposit:'true'}}
        ],
        sections:sectionsForUpdate(),
        sections_url:window.location.pathname
      });
      const cart = await currentCart();
      if (added.sections) cart.sections = added.sections;
      publish(cart);
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.show(button);
      else if (window.FoxTheme?.settings?.cartType === 'page') {
        window.location.href = window.FoxTheme.routes.cart_url;
      }
    } catch (error) {
      errorMessage(error);
    } finally {
      busy = false;
      button?.removeAttribute('aria-disabled');
      button?.classList.remove('btn--loading');
    }
  }, true);
})();